import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import {
    defaultIdentifyExperienceFormValues,
    identifyExperienceSchema,
    type IdentifyExperienceFormValues,
} from './IdentifyExperienceStep.schema';

export function useIdentifyExperienceStepForm(defaultValues?: Partial<IdentifyExperienceFormValues>) {
    return useForm<IdentifyExperienceFormValues>({
        mode: 'all',
        defaultValues: { ...defaultIdentifyExperienceFormValues, ...defaultValues },
        resolver: zodResolver(identifyExperienceSchema),
    });
}
